import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import TextButton from 'LuxKit/Button/TextButton'
import { preventDefault } from 'lib/web/eventHandlerUtils'
import type { NudgeAnswer, NudgeOption } from './tripDetailsNudgeAnswers'

interface Props {
  answer: NudgeAnswer<NudgeOption>
  /** Called with this answer's key and the sentence it adds to the draft */
  onClick: (option: NudgeOption, sentence: string) => void
}

function TripDetailsNudgeAnswer({ answer, onClick }: Props) {
  const intl = useIntl()
  const sentence = intl.formatMessage(answer.sentence)

  const handleClick = useCallback(() => {
    onClick(answer.key, sentence)
  }, [answer.key, onClick, sentence])

  return (
    <TextButton kind="secondary" shape="round" size="small" onMouseDown={preventDefault} onClick={handleClick}>
      {intl.formatMessage(answer.label)}
    </TextButton>
  )
}

export default TripDetailsNudgeAnswer
